import Container from "../components/Layout/Container";
import { useTranslation } from "react-i18next";
import InternLinkButton from "../components/button/InternLinkButton";
import { setSidetittel } from "../utils/common";
import { ButtonGroup } from "../components/button/ButtonGroup";
import EksternLinkButton from "../components/button/EksternLinkButton";
import { useRedirectUrl } from "../hooks/useRedirectUrl";
import Heading from "../components/sheriff-wrappers/Heading";

const UtloggetSide = () => {
  const { t } = useTranslation("skjematekst", {
    keyPrefix: "auth.utloggetSide",
  });
  setSidetittel(t("tittel"));
  const { urlTilInnlogging } = useRedirectUrl();
  return (
    <Container className={"sds-spacing-p-b-md"}>
      <Heading>{t("tittel")}</Heading>
      <p className={"sds-spacing-m-b-md"}>{t("automatiskInfo")}</p>
      <ButtonGroup>
        <EksternLinkButton
          text={t("logginn")}
          navigateTo={urlTilInnlogging}
          trackingName={"Logg inn"}
        />
        <InternLinkButton
          buttonType={"secondary"}
          text={t("forsiden")}
          navigateTo={"/"}
          trackingName={"Til oversikten"}
        />
      </ButtonGroup>
    </Container>
  );
};
export default UtloggetSide;
